window.addEventListener("DOMContentLoaded", () => {
    const { next, prev } = useCarousel(".carousel-layout");

    const prevEl = document.querySelector(".prev") as HTMLElement;
    const nextEl = document.querySelector(".next") as HTMLElement;

    prevEl.addEventListener("click", () => {
        prev();
    });

    nextEl.addEventListener("click", () => {
        next();
    });
});


function useCarousel(containerSelectors: string) {

    const container = document.querySelector(containerSelectors) as HTMLElement;
    if (!container) {
        throw new Error("container 不存在");
    }

    const track = container.querySelector(".carousel-track") as HTMLElement;
    if (!track) {
        throw new Error("track 不存在");
    }

    const items = track.querySelectorAll(".carousel-item");
    if (items.length < 3) {
        throw new Error("轮播图至少需要 3 个项目");
    }

    const { leftCloneDomList, rightCloneDomList } = initClone();


    const state = {
        currentIndex: leftCloneDomList.length,
        total: items.length + leftCloneDomList.length + rightCloneDomList.length,

        originalTotal: items.length,
        leftCloneCount: leftCloneDomList.length,
        rightCloneCount: rightCloneDomList.length,

        isAnimating: false, // 动画锁，防止快速点击穿帮

        // 当前在第一张原始项，要点上一张 -> 需要先动画到左侧克隆，再在结束时跳到"最后一张原始项"
        prevIsCritical() {
            const cur = state.currentIndex;
            const target = cur - 1;
            const atFirstOriginal = cur === state.leftCloneCount;
            const toLastLeftClone = target === state.leftCloneCount - 1;
            return atFirstOriginal && toLastLeftClone;
        },
        // 当前在最后一张原始项，要点下一张 -> 需要先动画到右侧克隆，再在结束时跳到"第一张原始项"
        nextIsCritical() {
            const cur = state.currentIndex;
            const target = cur + 1;
            const atLastOriginal = cur === state.leftCloneCount + state.originalTotal - 1;
            const toFirstRightClone = target === state.leftCloneCount + state.originalTotal;
            return atLastOriginal && toFirstRightClone;
        },
    }


    // 为所有item设置上  translateX
    updateView(false)


    /**
     * 初始化克隆元素
     */
    function initClone() {
        const leftCloneDomList = [
            items[items.length - 2].cloneNode(true) as HTMLElement,
            items[items.length - 1].cloneNode(true) as HTMLElement,
        ];

        const rightCloneDomList = [
            items[0].cloneNode(true) as HTMLElement,
            items[1].cloneNode(true) as HTMLElement,
        ];

        track.appendChild(rightCloneDomList[0]);
        track.appendChild(rightCloneDomList[1]);

        track.insertBefore(leftCloneDomList[1], items[0]);
        track.insertBefore(leftCloneDomList[0], leftCloneDomList[1]);

        return {
            leftCloneDomList,
            rightCloneDomList,
        };
    }


    /**
     * 动画结束后的回调封装
     * @param callback 动画结束后额外执行的操作（如临界跳转）
     */
    function onTransitionEnd(callback?: () => void) {
        state.isAnimating = true;
        const handler = function () {
            track.removeEventListener("transitionend", handler);
            if (callback) callback();
            state.isAnimating = false;
        };
        track.addEventListener("transitionend", handler, false);
    }

    function prev() {
        if (state.isAnimating) return;

        if (state.prevIsCritical()) {
            // 临界：动画到左侧克隆，结束后瞬间跳到"最后一张原始项"
            onTransitionEnd(() => {
                moveTo(state.leftCloneCount + state.originalTotal - 1, false);
            });
            moveTo(state.currentIndex - 1);
            return;
        }

        onTransitionEnd();
        moveTo(state.currentIndex - 1);
    }

    function next() {
        if (state.isAnimating) return;

        if (state.nextIsCritical()) {
            // 临界：动画到右侧克隆，结束后瞬间跳到"第一张原始项"
            onTransitionEnd(() => {
                moveTo(state.leftCloneCount, false);
            });
            moveTo(state.currentIndex + 1);
            return;
        }

        onTransitionEnd();
        moveTo(state.currentIndex + 1);
    }

    function moveTo(targetIndex: number, animation = true) {
        if (targetIndex < 0 || targetIndex >= state.total) {
            return;
        }

        state.currentIndex = targetIndex;
        updateView(animation);
    }


    function updateView(animation = true) {
        // 使用 concat 替代展开运算符，兼容 IE10
        var allItems: HTMLElement[] = [];
        allItems = allItems.concat(leftCloneDomList);
        for (var i = 0; i < items.length; i++) {
            allItems.push(items[i] as HTMLElement);
        }
        allItems = allItems.concat(rightCloneDomList);

        const index = state.currentIndex;


        for (let i = 0; i < allItems.length; i++) {
            const item = allItems[i] as HTMLElement;

            if (animation === false) {
                (item.style as any).msTransition = "none"; // IE10
                item.style.transition = "none";
            } else {
                (item.style as any).msTransition = ""; // IE10
                item.style.transition = "";
            }

            var distance = Math.abs(index - i);
            var scale = Math.max(0.7, 1 - distance * 0.1); // 最小缩放 0.7，防止过小

            // (index - 1) 让当前图片显示在中间位置，而不是最左边
            var transformValue = "translateX(-" + ((index - 1) * 100) + "%) scale(" + scale + ")";
            (item.style as any).msTransform = transformValue; // IE10
            item.style.transform = transformValue;
        }
    }

    return {
        prev,
        next,
        moveTo,
    };
}
